import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { MenuItem, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material'

import { InternalCategoryFeature } from '../../../../types/InternalCategory'

type FeatureChoiceAnswerProps = {
  feature: InternalCategoryFeature
  answer?: number
  disabled?: boolean
  onSelect: (weightId?: number) => void
  onToggle: (weightId: number) => void
}

// Legacy shows a select for more than two choices and toggle buttons otherwise.
export const FeatureChoiceAnswer: FC<FeatureChoiceAnswerProps> = ({ feature, answer, disabled, onSelect, onToggle }) => {
  const { t } = useTranslation()
  const isListed = feature.choices.some(({ weightId }) => weightId === answer)

  if (feature.choices.length > 2) {
    return (
      <TextField
        select
        size="small"
        fullWidth
        value={isListed ? answer : ''}
        disabled={disabled}
        SelectProps={{ displayEmpty: true }}
        inputProps={{ 'aria-label': t('internal-analysts:analysis_choices_answer_for', { name: feature.name }) }}
        onChange={(event) => onSelect(event.target.value === '' ? undefined : Number(event.target.value))}
      >
        <MenuItem value="">
          <em>{t('internal-analysts:analysis_choices_select_answer')}</em>
        </MenuItem>
        {feature.choices.map((choice) => (
          <MenuItem key={choice.weightId} value={choice.weightId}>
            {choice.choice.trim()}
          </MenuItem>
        ))}
      </TextField>
    )
  }

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={isListed ? answer : null}
      disabled={disabled}
      aria-label={t('internal-analysts:analysis_choices_answer_for', { name: feature.name })}
    >
      {feature.choices.map((choice) => (
        <ToggleButton
          key={choice.weightId}
          value={choice.weightId}
          onClick={() => onToggle(choice.weightId)}
          sx={{
            px: 2,
            textTransform: 'none',
            '&.Mui-selected:not(.Mui-disabled), &.Mui-selected:not(.Mui-disabled):hover': { bgcolor: 'secondary.main', color: 'common.white' },
          }}
        >
          {choice.choice.trim()}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
